/**
 * Generates a WhatsApp link with pre-filled message
 * @param phoneNumber - Phone number in international format (e.g., "+91 95095 04837")
 * @param brandName - Business name to be included in the message
 * @returns WhatsApp Web link with message template
 */
export const generateWhatsAppLink = (
  phoneNumber: string,
  brandName: string
): string => {
  // Remove spaces, dashes, parentheses from phone number
  const cleanPhone = phoneNumber.replace(/[\s\-()]/g, '');

  // Message template - single \n between paragraphs, no extra spaces
  const lines = [
    `Hey! I visited *${brandName}* and the food was amazing 🙌`,
    `I'm Dhruv, just checked and noticed you guys don't have a website yet - which honestly surprised me because most restaurants nearby are already showing up on Google with their own sites, and building their brand online.`,
    `Would you like to hop on a quick call to discuss what a website could do for you? It's totally free. We can go over ideas, what to include, and how it could look for your place.`,
    `Portfolio: dhruvx.dev`
  ];
  const messageTemplate = lines.join('\n');

  // URL encode the message (using encodeURIComponent handles all special chars and emojis)
  const encodedMessage = encodeURIComponent(messageTemplate);

  // Generate WhatsApp Web link
  return `https://wa.me/${cleanPhone}?text=${encodedMessage}`;
};
